<div class="wrapper">
  <div class="heading">
    <h6>{{ 'labels.unavailabilities' | translate }}</h6>

    <onyx-toggle
      [label]="`${I18N}.pastUnavailabilities`"
      [(checked)]="showPastUnavailabilities"
      [size]="32"
    ></onyx-toggle>
  </div>

  @if (showAdd()) {
    <onyx-button
      bottomLeftOptions
      class="add"
      color="black"
      variant="outlined"
      [size]="32"
      leftIcon="add-outlined"
      [disabled]="!enabled()"
      (click)="enabled() ? addUnavailability() : null"
    >
      {{ 'labels.add' | translate }}
    </onyx-button>
  }
</div>

<onyx-table
  [data]="unavailabilities()"
  [columns]="COLUMNS"
  [loading]="loading()"
  [(error)]="error"
  [tableShadow]="false"
  [rowSize]="48"
  [notFound]="UNAVAILABILITIES_NOT_FOUND"
  [(pagination)]="pagination"
  (rowClick)="editUnavailability($event.item)"
  (errorChange)="reload$.next()"
></onyx-table>
